<template>
  <div class="map-selection-container">
    <div
      class="map-selection"
      v-if="!selectedLocation"
      @click="handleMaskClick"
    >
      <div class="openBtn">选择地图位置</div>
    </div>
    <div class="map-selection" v-else>
      <el-amap
        ref="viewMap"
        @init="initMap"
        :zoom="zoom"
        :center="center"
        :resizeEnable="false"
        :dragEnable="false"
        :zoomEnable="false"
        class="amap"
      >
        <!-- 标记点 -->
        <el-amap-marker
          :position="selectedLocation.position"
          :label="{
            content: selectedLocation.name || '已选择位置',
            direction: 'top',
          }"
        />
      </el-amap>
      <div class="mask-btn" @click="handleMaskClick">请选择地点 (点击选择)</div>
    </div>
    <SelectLocation ref="selectLocation" @confirm="handleConfirm" />
  </div>
</template>

<script>
import SelectLocation from "./select.vue";
export default {
  components: {
    SelectLocation,
  },
  data() {
    return {
      center: [113.666502, 34.752278],
      zoom: 10,
      selectedLocation: null,
    };
  },
  props: {
    enterpriseData: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    initMap(map) {
      this.map = map;
    },
    handleMaskClick() {
      if (this.enterpriseData?.showinfo_audit_status == 0) {
        this.$message.error("审核中，不可重复提交！");
        return false;
      }
      this.$refs.selectLocation.open(this.selectedLocation || null);
    },
    handleConfirm(item) {
      item.position = item.position.toArray();
      this.selectedLocation = item;
      this.center = item.position;
      this.zoom = 15;
      this.$emit("confirm", {
        province: item.province || "",
        city: item.city || "",
        district: item.district || "",
        lng: item.position[0],
        lat: item.position[1],
        name: item.name || "",
        address: item.address || "",
      });
    },
    setLocation(location) {
      if (location) {
        location.position = [location.lng, location.lat];
        this.selectedLocation = location;
        this.center = location.position;
        this.zoom = 15;
      } else {
        this.selectedLocation = null;
        this.center = [113.666502, 34.752278];
        this.zoom = 10;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.map-selection-container {
  width: 100%;
  height: 100%;

  .map-selection-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 10px;
    cursor: pointer;
  }
}

.map-selection {
  width: fit-content;
  height: 100%;
  position: relative;
  overflow: hidden;

  &:hover {
    .mask {
      top: 0;
    }
  }

  .openBtn {
    width: 112px;
    flex-shrink: 0;
    border-radius: 4px;
    background: #f32432;
    color: #ffffff;
    text-align: center;
    font-family: "PingFang SC";
    font-size: 14px;
    font-weight: 500;
    line-height: 36px;
    cursor: pointer;
    margin-top: 7px;
  }

  .amap {
    width: 100%;
    height: 100%;
  }

  .mask {
    transition: top 0.3s ease-in-out;
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    z-index: 1000;
    cursor: pointer;
  }
}

/deep/ .amap-logo {
  display: none !important;
}

/deep/ .amap-copyright {
  display: none !important;
}

.mask-btn {
  position: absolute;
  padding: 4px 15px;
  font-size: 14px;
  color: #333;
  background-color: #fff;
  border-radius: 100px;
  right: 10px;
  bottom: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  cursor: pointer;
}
</style>